import { FC, useMemo } from "react";

import { getRideStationById, IStationWrapperRideProps } from "@ryde/shared";

import { RideStation } from "./ride-station";
import { RideStationGreyed } from "./ride-station-greyed";

export const RideStationWrapper: FC<IStationWrapperRideProps> = ({
  stationComposedId,
  rideDto,
  index,
  isLastStation,
  isFirstStation,
  mode,
  isGreyed,
}) => {
  const station = useMemo(() => {
    return getRideStationById({ rideDto, stationComposedId });
  }, [rideDto, stationComposedId]);
  return (
    <>
      {station && !isGreyed && (
        <RideStation
          station={station}
          rideDto={rideDto}
          isLastStation={isLastStation}
          isFirstStation={isFirstStation}
          mode={mode}
          index={index}
        />
      )}
      {station && isGreyed && (
        <RideStationGreyed
          station={station}
          rideDto={rideDto}
          isLastStation={isLastStation}
          isFirstStation={isFirstStation}
          mode={mode}
          index={index}
        />
      )}
    </>
  );
};
